// ABOUTME: Derives the configurator's hideOptionCode prop from a resolved product.
// ABOUTME: True when the model opted into hiding option codes (the server flags the product).

import { ConfiguratorProduct } from './configuratorProduct';

/**
 * The server attaches hideOptionCode to the product returned by apply-assignments when the model
 * node has the flag set; false when the flag (or the product) is missing.
 */
export const getHideOptionCode = (product: ConfiguratorProduct | undefined): boolean =>
    !!product?.hideOptionCode;
